// utils
import React from "react";
import { useMatch } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

// custom utils
import { getCurrentLanguage, LANGUAGES } from "../../utils/langUtils";

// translations
import translation_cs from "./lang/cs.json";
import translation_en from "./lang/en.json";
import translation_de from "./lang/de.json";

// page sections
import GrantsMars from "./components/grants-mars/grants-mars";

/**
 * list of grant tiles shown on the page (top to bottom)
 * - to add a new grant create its component (see grants-mars) and append it here
 * - tiles automatically alternate sides (zig-zag layout same as OUR-WORK & BLOG)
 */
const GRANTS = [GrantsMars];

/**
 * GRANTS page
 * presents grant (EU co-financed) projects - one tile per grant
 * @returns HTML element for GRANTS page
 */
export default function Index() {

    const match = useMatch("/:lang/*");
    let lang = (match && match.params.lang) ? match.params.lang : "";
    let translation = translation_cs;

    let language = getCurrentLanguage(lang);
    switch (language) {
        case LANGUAGES.Czech:
            translation = translation_cs;
            break;
        case LANGUAGES.English:
            translation = translation_en;
            break;
        case LANGUAGES.German:
            translation = translation_de;
            break;
    }

    return (
        <>
            <div className="fade-in-750">
                <div className="bg-divelit-grey-90 navbar-size-compensation">
                    <div className="pt-3 pt-lg-5 pb-3 pb-lg-5">
                        <Container className="pt-3 pt-lg-5 pb-3 pb-lg-5">
                            <Row>
                                <Col xs={12} sm={12} md={10} lg={8} xl={7}>
                                    <h1 className="font-white fade-in-750-down-to-top">
                                        {translation.header.part1} <span className="font-divelit-lemon">{translation.header.part2}</span>
                                    </h1>
                                    <p className="paragraph-medium font-white mt-3 mt-md-5 mb-0 fade-in-1000-down-to-top">{translation.paragraph}</p>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <hr className="sepparator-horiz-divelit-grey-30"></hr>
                </div>
                {GRANTS.map((Grant, index) =>
                    <Grant key={index} side={index % 2 === 0 ? "start" : "end"}></Grant>
                )}
            </div>
        </>
    );
}
